import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { CloseIcon } from '../../../assets/svgs/icons'
import styles from './styles.module.css'

const STYLE_LABEL_KEYS = {
  minimalista: 'chatsocket.visual_style.options.minimalist',
  premium: 'chatsocket.visual_style.options.premium',
  vibrante: 'chatsocket.visual_style.options.vibrant',
  'preto-e-branco': 'chatsocket.visual_style.options.black_and_white',
  realismo: 'chatsocket.visual_style.options.realism',
  fantasioso: 'chatsocket.visual_style.options.fantasy',
}

const DEFAULT_STYLES = [
  {
    id: 'minimalista',
    label: 'Minimalista',
    imageUrl: 'https://m.media-amazon.com/images/I/619wSFAi9VL._AC_UF894,1000_QL80_.jpg'
  },
  {
    id: 'premium',
    label: 'Premium',
    imageUrl: 'https://images.tcdn.com.br/img/img_prod/1162999/1681835971_full-banner-mobile-1.jpg'
  },
  {
    id: 'vibrante',
    label: 'Vibrante',
    imageUrl: 'https://images.unsplash.com/photo-1513151233558-d860c5398176?w=800&h=400&fit=crop&auto=format'
  },
  {
    id: 'preto-e-branco',
    label: 'Preto e Branco',
    imageUrl: 'https://wallpapers.com/images/featured/fundo-de-arte-em-preto-e-branco-9i0965pyr4th0pgw.jpg'
  },
  {
    id: 'realismo',
    label: 'Realismo',
    imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQNPkRSzsBj_hY0rl8Bg6EDPoe7rLRqKcBj5Q&s'
  },
  {
    id: 'fantasioso',
    label: 'Fantasioso',
    imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3bW2K9i7qica1WLKAomR_Ucf77HndT7AeWw&s'
  }
]

export const VisualStyleSelector = ({ isOpen, onClose, onSave, styleOptions: customStyleOptions, preselectedStyle }) => {
  const { t } = useTranslation()
  const [selectedStyle, setSelectedStyle] = useState(null)
  
  const styleOptions = customStyleOptions && customStyleOptions.length > 0 ? customStyleOptions : DEFAULT_STYLES

  // Quando o modal abre, se houver um estilo pré-selecionado, seleciona ele
  useEffect(() => {
    if (isOpen && preselectedStyle) {
      setSelectedStyle(preselectedStyle.id)
    } else if (isOpen && !preselectedStyle) {
      setSelectedStyle(null)
    }
  }, [isOpen, preselectedStyle])

  if (!isOpen) return null

  const handleStyleSelect = (styleId) => {
    setSelectedStyle(styleId)
  }

  const handleSave = () => {
    if (selectedStyle && onSave) {
      const selectedStyleData = styleOptions.find(style => style.id === selectedStyle)
      onSave(selectedStyleData)
    }
    setSelectedStyle(null)
    onClose()
  }

  return (
    <div className={styles.container}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2 className={styles.title}>{t('chatsocket.visual_style.modal_title')}</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <CloseIcon color="#000" size="20" />
          </button>
        </div>
        <div>
          <p className={styles.instruction}>{t('chatsocket.visual_style.instruction')}</p>

          <div className={styles.stylesGrid}>
            {styleOptions.map((style) => (
              <div key={style.id} className={styles.styleItem}>
                <div className={styles.imageContainer}>
                  <img
                    src={style.imageUrl}
                    alt={t(STYLE_LABEL_KEYS[style.id] || style.label)}
                    className={styles.styleImage}
                    onError={(e) => {
                      e.target.style.display = 'none'
                      e.target.nextSibling.style.display = 'flex'
                    }}
                  />
                  <div className={styles.imagePlaceholder} style={{ display: 'none' }}>
                    {t(STYLE_LABEL_KEYS[style.id] || style.label)}
                  </div>
                </div>
                <button
                  className={`${styles.styleButton} ${
                    selectedStyle === style.id ? styles.styleButtonSelected : ''
                  }`}
                  onClick={() => handleStyleSelect(style.id)}
                >
                  {t(STYLE_LABEL_KEYS[style.id] || style.label)}
                  {selectedStyle === style.id && (
                    <span className={styles.checkmark}>✓</span>
                  )}
                </button>
              </div>
            ))}
          </div>
        </div>

        <button 
          className={styles.saveButton} 
          onClick={handleSave}
          disabled={!selectedStyle}
        >
          {t('chatsocket.buttons.save_response')}
        </button>
      </div>
    </div>
  )
}
